import Vue from 'vue'
import Router from 'vue-router'
import { app } from './main'

const MOSAIC_COMPONENT_IDENTIFIER = 'Mosaic'

Vue.use(Router)

function load (component) {
  return () => import(`@/views/${component}.vue`)
}
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: load('intro')
    },
    {
      path: '/trabalhos',
      name: 'portfolio',
      component: load('portfolio')
    },
    {
      path: '/trabalhos/lenossa',
      name: 'lenossa',
      component: load('lenossa')
    },
    {
      path: '/trabalhos/dnare',
      name: 'dnare',
      component: load('dnare')
    },
    {
      path: '/trabalhos/paguru',
      name: 'paguru',
      component: load('paguru')
    }
  ]
})

const getMosaicComponent = () => {
  if (app && app.$children) {
    let mosaicComponent
    app.$children[0].$children.every(child => {
      if (child.$options.name.includes(MOSAIC_COMPONENT_IDENTIFIER)) {
        mosaicComponent = child
        return false
      }
      return true
    })
    return mosaicComponent
  }
  return undefined
}

router.beforeEach((to, from, next) => {
  const mosaicComponent = getMosaicComponent()
  if (mosaicComponent) mosaicComponent.toggleMosaic(next)
  else next()
})

export default router
